export default {
  groups: (state) => state.Groups
}
